import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorNodeRequest from "~/operatorApplication/ts/service/comet/OperatorNodeRequest";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import CoreUiChatHistoryHelper, {MessageStatusId} from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


export default class OperatorApplicationMessageStatus {
    private static setMessageStatus(
        client: CometOperatorApplication.OperatorApplicationClientOpenApiModel,
        statusId: MessageStatusId,
        message: CometOperatorApplication.OperatorApplicationMessageOpenApiModel
    ): boolean {
        let changed = message.statusId != statusId && message.statusId != "readed";
        if (changed) {
            let request = new OperatorNodeRequest("/setMessageStatusByOperator");
            let p: CometOperatorApplication.CometSetMessageStatusByOperatorBodyOpenApiModel = {
                orgId: OperatorAccountStore.data.value.orgId,
                siteId: client.siteId,
                clientId: client.clientId,
                id: message.id,
                status: statusId,
                isCrossOperatorsChat: CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(client),
                receiver: OperatorAccountStore.operator.value.login,
                chatId: client.username,
                token: OperatorAccountStore.tokenId.value
            };
            request.setBody(p).send();
            message.statusId = statusId;
        }
        return changed;
    }

    public static setMessageStatusDelivered(
        client: CometOperatorApplication.OperatorApplicationClientOpenApiModel,
        message: CometOperatorApplication.OperatorApplicationMessageOpenApiModel
    ): boolean {
        return this.setMessageStatus(client, "delivered", message);
    }

    public static setMessageStatusReaded(
        client: CometOperatorApplication.OperatorApplicationClientOpenApiModel,
        message: CometOperatorApplication.OperatorApplicationMessageOpenApiModel
    ): boolean {
        if (client.unreadedMessageIds) {
            let messageIds = client.unreadedMessageIds.filter(id => id > message.id);
            ClientUserdataStore.UPDATE_UNREADED_MESSAGE_ID_LIST({
                username: client.username,
                messageIds: messageIds,
                adminMessageIds: [],
                mentionMessageIds: client.unreadedMentionMessageIds.filter(id => id > message.id),
                crossOperatorConversationUnreadMessageCount: client.crossOperatorConversationUnreadMessageCount
            });

            let parentClientUsername = client.crossOperatorConversationParams?.parentUsername;
            if (parentClientUsername) {
                let parentClient = ClientUserdataStore.getByUsername(parentClientUsername, false);
                if (parentClient) {
                    parentClient.crossOperatorConversationUnreadMessageCount = messageIds.length;
                }
            }
        }
        return this.setMessageStatus(client, "readed", message);
    }
}

